import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

export const fetchComponents = async (packageId) => {
  const res = await axios.get(`${baseUrl}/components?PackageID=${packageId}`);
  return Array.isArray(res.data) ? res.data : [];
};

export const addComponent = async (data) => {
  return axios.post(`${baseUrl}/components`, data);
};

export const updateComponent = async (compId, data) => {
  return axios.put(`${baseUrl}/components/${compId}`, data);
};

export const deleteComponent = async (compId) => {
  return axios.delete(`${baseUrl}/components/${compId}`);
};

export const moveComponentUp = async (compId) => {
  return axios.post(`${baseUrl}/components/${compId}/move-up`);
};

export const moveComponentDown = async (compId) => {
  return axios.post(`${baseUrl}/components/${compId}/move-down`);
};
